module.exports = __webpack_public_path__ + "media/images/landing_hero_large-783b73bcc2f67635cc9db210d392ae8a.jpg";